import { axiosInstance } from '@/lib/services/axiosinstance'
import { useAuth } from './useAuth'
import { API_URL } from '@/lib/constants'
import { adaptCourseMaterials, type CourseMaterials } from '../lib/helpers'

export function useWorkbooks() {
  const { getAuthHeaders } = useAuth()

  // async function listWorkbooks(): Promise<CourseMaterials[]> {
  //   try {
  //     const url = `${API_URL}/user_api/v1/users/get_user_course_materials.json`
  //     const res = await axiosInstance.get(url, { headers: getAuthHeaders() })
  //     const data = await res.data
  //     const adapted = adaptCourseMaterials(data)
  //     return adapted
  //   } catch (e) {
  //     console.error(e)
  //     return []
  //   }
  // }
  // return { listWorkbooks }

    async function listWorkbooks(): Promise<CourseMaterials[]> {
    try {
      const url = `${API_URL}/user_api/v1/users/get_user_course_materials`
      const res = await axiosInstance.get(url, { headers: getAuthHeaders() })
      const data = await res.data
      console.log('Fetched course materials:', data)
      const adapted = adaptCourseMaterials(data)
      return adapted
    } catch (e) {
      console.error(e)
      return []
    }
  }
  return { listWorkbooks }
}